import React, { useState, useEffect } from 'react';
import { WifiOff, Download, MapPin } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { getAllOfflineAreas } from '../services/tileDownloaderService';
import { BRAND_DARK } from '../constants/mapColors';

interface OfflineBannerProps {
  isOffline: boolean;
}

const OfflineBanner: React.FC<OfflineBannerProps> = ({ isOffline }) => {
  const { t } = useTranslation();
  const [offlineAreaCount, setOfflineAreaCount] = useState(0);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (isOffline) {
      const areas = getAllOfflineAreas().filter(a => a.status === 'complete');
      setOfflineAreaCount(areas.length);
      setDismissed(false);
    }
  }, [isOffline]);

  if (!isOffline || dismissed) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed top-0 left-0 right-0 z-[5000] text-white text-center py-2 px-4 flex items-center justify-center gap-2 text-xs font-bold cursor-pointer"
      style={{ background: offlineAreaCount > 0 ? BRAND_DARK : '#f59e0b', paddingTop: 'max(env(safe-area-inset-top, 0px), 8px)' }}
      onClick={() => setDismissed(true)}
    >
      {offlineAreaCount > 0 ? (
        <>
          <MapPin size={14} />
          <span>{t('offline.using_cached', 'Offline — bruker {{count}} nedlastet kartområde', { count: offlineAreaCount })}</span>
        </>
      ) : (
        <>
          <WifiOff size={14} />
          <span>{t('offline.banner', 'Du er offline')}</span>
          <span className="opacity-80 ml-1">· {t('offline.no_maps', 'Ingen kart lastet ned')}</span>
        </>
      )}
    </div>
  );
};

export default OfflineBanner;
